var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19. Bank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "19.-Bank",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0000002,2 C50.0000002,2 1.42779378,27.7656332 2.00510582,27.7945661 L2.00510582,34.64 L97.9948945,34.64 L97.9948945,27.7944731 C98.5721884,27.7655989 50.0000002,2 50.0000002,2 L50.0000002,2 L50.0000002,2 Z",
    id: "Layer-1",
    stroke: "#222F3E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Layer-2",
    stroke: "#222F3E",
    strokeWidth: 4,
    points: "30 44 30 80.6294886 12.72 80.6294886 12.72 44 10 44 10 35 32.16 35 32.16 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Layer-3",
    stroke: "#222F3E",
    strokeWidth: 4,
    points: "59 44 59 80.6294886 41.72 80.6294886 41.72 44 39 44 39 35 61.16 35 61.16 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Layer-4",
    stroke: "#222F3E",
    strokeWidth: 4,
    points: "88 44 88 80.6294886 70.72 80.6294886 70.72 44 68 44 68 35 90.16 35 90.16 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Layer-5",
    stroke: "#222F3E",
    strokeWidth: 4,
    points: "89.744 88.5432836 89.744 80.72 10.256 80.72 10.256 88.5432836 6.8 88.5432836 6.8 98 93.2 98 93.2 88.5432836"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bankIcon.d9975ecf80b8c50c3fdb84c60364234a.svg";
export { ForwardRef as ReactComponent };